import React from "react";
import Text from "../text";
import {
  SituationCardContainer,
  DescriptionContainer,
  BoutonContainer,
} from "./styled-components";
import { ReactComponent as NextIcon } from "../../assets/icons/next.svg";

const SituationCard = ({
  title,
  description,
  color,
  onClick,
}: SituationCardProps) => {
  return (
    <SituationCardContainer color={color} onClick={onClick}>
      <DescriptionContainer>
        <Text size="16px" lineHeight="18px" weight={700}>
          {title}
        </Text>
        <Text color="grey500" size="18px" lineHeight="18px" weight={600}>
          {description}
        </Text>
      </DescriptionContainer>
      <BoutonContainer onClick={onClick}>
        <NextIcon />
      </BoutonContainer>
    </SituationCardContainer>
  );
};

export default SituationCard;
